import { render, staticRenderFns } from "./StudentGradesDetails.vue?vue&type=template&id=635ed2fa"
import script from "./StudentGradesDetails.vue?vue&type=script&lang=js"
export * from "./StudentGradesDetails.vue?vue&type=script&lang=js"
import style0 from "./StudentGradesDetails.vue?vue&type=style&index=0&id=635ed2fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports